import React from "react";
import { Navigate } from "react-router-dom";
import { useAuthStore } from "../stores/auth.store";
import { Role } from "../types/auth.type";
import { getHomeRoute, hasAnyRole } from "../utils/roles";
import Layout from "./Layout";

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles: Role[];
  redirectTo?: string;
  onThemeToggle: () => void;
  withLayout?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  allowedRoles,
  redirectTo,
  onThemeToggle,
  withLayout = true,
}) => {
  const { isAuthenticated, isAdmin, isManager, isCoach, user } = useAuthStore();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!hasAnyRole(user, allowedRoles)) {
    const fallback = redirectTo ?? getHomeRoute(isAdmin, isManager, isCoach);
    return <Navigate to={fallback} replace />;
  }

  if (!withLayout) {
    return <>{children}</>;
  }

  return <Layout onThemeToggle={onThemeToggle}>{children}</Layout>;
};

export default ProtectedRoute;
